import {
    IconBox,
    IconBrandCodepen,
    IconCalculator,
    IconForklift,
    IconReport,
    IconUser,
    IconUserShield
} from '@tabler/icons-react';

export const MENU_ITEMS = [
    {
        label: 'Calculator',
        icon: IconCalculator,
        links: [
            { label: 'Allocation', link: '/allocation', access: 'Admin' },
            { label: 'Restock', link: '/restock', access: 'Admin' },
        ],
        access: 'Admin'
    },
    {
        label: 'User',
        icon: IconUser,
        links: [
            { label: 'Floor User', link: '/floorUser', access: 'Admin' },
            { label: 'Restock User', link: '/restockUser', access: 'Admin' },
            { label: 'Bin', link: '/bin', access: 'Admin' },
        ],
        access: 'Admin'
    },
    {
        label: 'Forklift',
        icon: IconForklift,
        links: [
            { label: 'Pick orders', link: '/forklift', access: 'Forklift' },
            // { label: 'All Stores', link: '/multipleStores', access: 'Forklift' },
            { label: 'Print Label', link: '/printLabel', access: 'Forklift' },
        ],
        access: 'Forklift'
    },
    {
        label: 'Operations', icon: IconBrandCodepen,
        links: [
            { label: 'Print label', link: '/printLabel', access: 'Admin' },
            { label: 'Style Alloc', link: '/styleAlloc', access: 'Admin' },
            { label: 'Driver Info', link: '/driverInfo', access: 'SuperAdmin' },
        ],
        access: 'Admin'
    },
    {
        label: 'HR', icon: IconUserShield,
        links: [
            { label: 'Manage Users', link: '/manageUsers', access: 'Hr' },
            { label: 'Stats', link: '/stats', access: 'Hr' },
            { label: 'Forklift', link: '/forkliftDashboard', access: 'Hr' },
        ],
        access: 'Hr'
    },
    {
        label: 'Inventory',
        icon: IconBox,
        links: [
            { label: 'Transfer List', link: '/poList', access: 'Admin', data: { status: 'transferList' } },
            { label: 'Style List', link: '/styleList', access: 'Admin' },
            { label: 'PO Worksheet', link: '/poList', access: 'Admin', data: { status: 'poWorksheet' } },
        ],
        access: 'Admin'
    },
    {
        label: 'Admin', icon: IconReport,
        links: [
            { label: 'Users', link: '/users', access: 'SuperAdmin' },
            { label: 'Register', link: '/register', access: 'SuperAdmin' },
            { label: 'Modify Allocation', link: '/modifyAllocation', access: 'SuperAdmin' },
            { label: 'Automate Transfer', link: '/automateTransfer', access: 'SuperAdmin' },
            { label: 'Change Po', link: '/changeAllocation', access: 'SuperAdmin' },
        ],
        access: 'SuperAdmin'
    }

];

export const userAccess = ['/', '*', '/profile', '/login'];

export const forkliftAccess = [...userAccess, '/forklift', '/printLabel', '/multipleStores'];

export const adminAccess = [...userAccess,
    '/allocation',
    '/restock',
    '/floorUser',
    '/restockUser',
    '/bin',
    '/sheet',
    '/logSheet',
    '/printLabel',
    '/styleAlloc',
    '/styleList',
    '/transferList',
    '/poWorksheet',
    '/poList',
    '/poList',
    '/forklift',
    '/labels',
];

export const hrAccess = [...adminAccess,
    '/stats',
    '/manageUsers',
    '/forkliftDashboard',
];

export const superAdminAccess = [...hrAccess,
    '/users',
    '/userRoleAccess',
    '/deleteAllocation',
    '/register',
    '/modifyAllocation',
    '/automateTransfer',
    '/changeAllocation',
    '/forklift',
    '/multipleStores',
    '/driverInfo',
];